import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import qs from 'query-string';

var Artwork = /*#__PURE__*/function () {
  function Artwork(context) {
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Artwork);

    this.context = context;
    this.headers = headers;
  } // Updates


  _createClass(Artwork, [{
    key: "put",
    value: function put(id, params) {
      return this.context.http.put("/msvc/v1/artcatalog/artwork/item/".concat(id), params);
    } // Creates a new Artwork

  }, {
    key: "post",
    value: function post(params) {
      return this.context.http.post('/msvc/v1/artcatalog/artwork/item', params, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    } // Deletes an Artwork

  }, {
    key: "del",
    value: function del(id) {
      return this.context.http.del("/msvc/v1/artcatalog/artwork/item/".concat(id));
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.context.http.get("/msvc/v1/artcatalog/artwork/item/".concat(id), null, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
  }, {
    key: "mediums",
    value: function mediums() {
      return this.context.http.get('/msvc/v1/artcatalog/artwork/mediums');
    }
  }, {
    key: "updateProperties",
    value: function updateProperties(id, params) {
      return this.context.http.put("/msvc/v1/artcatalog/artwork/item/".concat(id, "/properties"), params, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
  }, {
    key: "updatePropertiesBulk",
    value: function updatePropertiesBulk(params) {
      return this.context.http.post('/msvc/v1/artcatalog/artwork/items/properties', params, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
  }, {
    key: "postForEvent",
    value: function postForEvent(params) {
      return this.context.http.post('/msvc/v1/artcatalog/artwork/forEvent', params);
    }
  }, {
    key: "deleteArtwork",
    value: function deleteArtwork(id) {
      return this.context.http.del("/msvc/v1/artcatalog/artwork/item/".concat(id));
    }
  }, {
    key: "getAllArtworks",
    value: function getAllArtworks(params) {
      return this.context.http.get('/msvc/v1/artcatalog/artwork/items', params, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
  }, {
    key: "postUnlinkedArtwork",
    value: function postUnlinkedArtwork(params) {
      return this.context.http.post('/msvc/v1/artcatalog/artwork/forAdministrator', params);
    }
  }, {
    key: "postArtworkForShowSector",
    value: function postArtworkForShowSector(params) {
      return this.context.http.post('/msvc/v1/artcatalog/artwork/forShow', params);
    }
  }, {
    key: "getItemIds",
    value: function getItemIds(params) {
      return this.context.http.get('/msvc/v1/artcatalog/artwork/itemIds', params, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
  }, {
    key: "getItemDetails",
    value: function getItemDetails(params) {
      return this.context.http.get("/msvc/v1/artcatalog/artwork/itemDetails?".concat(qs.stringify(params)), null, {
        headers: {
          'cache-control': 'no-cache'
        }
      });
    }
  }]);

  return Artwork;
}();

export default Artwork;